export var BusinessAffiliateRewardModel;
(function (BusinessAffiliateRewardModel) {
    BusinessAffiliateRewardModel["FeeShare"] = "FEE_SHARE";
    BusinessAffiliateRewardModel["FlatAtThreshold"] = "FLAT_AT_THRESHOLD";
    BusinessAffiliateRewardModel["VolumePercentage"] = "VOLUME_PERCENTAGE";
})(BusinessAffiliateRewardModel || (BusinessAffiliateRewardModel = {}));
//# sourceMappingURL=BusinessAffiliateRewardModel.js.map